import { render, staticRenderFns } from "./ForumContextSiteHeader.vue?vue&type=template&id=279e58a8&scoped=true"
import script from "./ForumContextSiteHeader.vue?vue&type=script&lang=js"
export * from "./ForumContextSiteHeader.vue?vue&type=script&lang=js"
import style0 from "./ForumContextSiteHeader.vue?vue&type=style&index=0&id=279e58a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279e58a8",
  null
  
)

export default component.exports